import { Link } from 'react-router-dom';

/**
 * Header component with logo and navigation
 */
function Header() {
	return (
		<header className="header">
			<div className="header-container">
				<Link to="/" className="logo-link">
					<img 
						src={process.env.PUBLIC_URL + '/logo.png'} 
						alt="3oh logo" 
						className="logo"
					/>
				</Link>
				<nav className="nav">
					<a href="#services" className="nav-link">Services</a>
					<a href="#about" className="nav-link">About</a>
					<a href="mailto:hello@3oh.io" className="nav-link nav-cta">Contact</a>
				</nav>
			</div>
		</header>
	);
}

export default Header;
